import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { useCharacterFolder } from '../../hooks';
import { LayoutDataType } from '../../types';

import { BODY_SHAPE_OPTIONS } from './BODY_SHAPE_OPTIONS';
import { ScreenBodyShapeStyles } from './BodyShapeScreen.styles';

export const BodyShapeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'BodyShape',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { getAsset } = useCharacterFolder();
  const form = useFormContext<LayoutDataType>();
  const body_shape = form.watch('body_shape');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['body_shape']>,
  ) => {
    form.setValue('body_shape', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        body_shape: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <ScreenBodyShapeStyles>
      <OnboardingNavigation />

      <OwnAiTitle>
        Choose his <OwnAiTitleHighlight>body shape</OwnAiTitleHighlight>
      </OwnAiTitle>

      <IonContent>
        <OptionItemSquareList>
          {BODY_SHAPE_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={body_shape === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getAsset(`body_shape/${option.id}.png`)}
              title={option.title}
              TEST_ID={`body_shape-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </ScreenBodyShapeStyles>
  );
};
